import { type FC, type ReactNode, useMemo, useState } from "react";
import EngagementSectionPagination from "./EngagementSectionPagination";

interface EngagementKpiCarouselProps {
  items: ReactNode[];
  pageSize?: number;
  emptyState?: ReactNode;
  ariaLabel: string;
}

const EngagementKpiCarousel: FC<EngagementKpiCarouselProps> = ({
  items,
  pageSize = 4,
  emptyState,
  ariaLabel,
}) => {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));

  const visibleItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, page, pageSize]);

  if (!items.length) {
    return (
      <div className="engagement-overview-kpi-carousel engagement-overview-kpi-carousel--empty">
        {emptyState ?? (
          <p className="engagement-overview-empty">No KPI data for the selected filters.</p>
        )}
      </div>
    );
  }

  return (
    <div className="engagement-overview-kpi-carousel">
      <div className="engagement-overview-kpi-carousel__grid">{visibleItems}</div>
      {totalPages > 1 ? (
        <EngagementSectionPagination
          currentPage={page}
          totalPages={totalPages}
          onPrev={() => setPage(current => Math.max(1, current - 1))}
          onNext={() => setPage(current => Math.min(totalPages, current + 1))}
          ariaLabel={ariaLabel}
        />
      ) : null}
    </div>
  );
};

export default EngagementKpiCarousel;
